export default {
  title: 'C3S Indicators Listing',

  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
  ],

  properties: {},
  required: [],
};
